import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class MainScrollService {
  mainScrollInfo = new Subject<any>();

  getMainScrollInfo(): Observable<any> {
    return this.mainScrollInfo.asObservable();
  }

  sendMainScrollInfo(scrollInfo: any): void {
    this.mainScrollInfo.next(scrollInfo);
  }
}